import React from "react";
const Label = (props) => {
    const classes = "text-gray-700 " + props.className;
    
    return (
        <label className={classes}>{props.children}</label>
    )
}
export default Label